import api from './api';

/**
 * Obtiene todas las conversiones de Google Ads con paginación y filtros
 * @param {Object} params - Objeto con parámetros de búsqueda
 * @returns {Promise} - Promesa con los resultados
 */
export const getConversions = async (params = {}) => {
  const queryParams = new URLSearchParams();
  
  // Añadir todos los parámetros a la URL
  Object.entries(params).forEach(([key, value]) => {
    // Solo añadir parámetros con valor
    if (value !== undefined && value !== null && value !== '') {
      if (key === 'dateRange' && value.startDate && value.endDate) {
        queryParams.append('startDate', value.startDate);
        queryParams.append('endDate', value.endDate);
      } else if (key !== 'dateRange') {
        // Cualquier otro parámetro
        queryParams.append(key, value);
      }
    }
  });
  
  const queryString = queryParams.toString();
  const response = await api.get(`/api/conversions?${queryString}`);
  return response.data;
};

/**
 * Obtiene una conversión por ID
 * @param {Number} id - ID de la conversión
 * @returns {Promise} - Promesa con la conversión
 */
export const getConversionById = async (id) => {
  const response = await api.get(`/api/conversions/${id}`);
  return response.data;
};

/**
 * Obtiene estadísticas de conversiones
 * @param {Object} params - Objeto con filtros (opcional)
 * @returns {Promise} - Promesa con las estadísticas
 */
export const getConversionStats = async (params = {}) => {
  const queryParams = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      if (key === 'dateRange' && value.startDate && value.endDate) {
        queryParams.append('startDate', value.startDate);
        queryParams.append('endDate', value.endDate);
      } else if (key !== 'dateRange') {
        queryParams.append(key, value);
      }
    }
  });
  const queryString = queryParams.toString();
  const response = await api.get(`/api/conversions/stats${queryString ? `?${queryString}` : ''}`);
  return response.data;
};

/**
 * Actualiza una conversión por ID
 * @param {Number} id - ID de la conversión
 * @param {Object} updateData - Datos a actualizar
 * @returns {Promise} - Promesa con el resultado
 */
export const updateConversion = async (id, updateData) => {
  const response = await api.put(`/api/conversions/${id}`, updateData);
  return response.data;
};

/**
 * Actualiza múltiples conversiones
 * @param {Array} conversionIds - Array de IDs de conversiones
 * @param {Object} updateData - Datos a actualizar
 * @returns {Promise} - Promesa con el resultado
 */
export const bulkUpdateConversions = async (conversionIds, updateData) => {
  const response = await api.put('/api/conversions/bulk-update', {
    conversionIds,
    ...updateData
  });
  return response.data;
};

/**
 * Solicita al backend que refresque la hora del evento de una conversión desde la API de CEM.
 * @param {number} id - ID de la conversión.
 * @returns {Promise<Object>} - Promesa con la conversión actualizada o un mensaje.
 */
export const refreshConversionEventTime = async (id) => {
  const response = await api.put(`/api/conversions/${id}/refresh-event-time`);
  return response.data; // El backend devuelve la conversión actualizada o un objeto con { message, conversion }
};

export default {
  getConversions,
  getConversionById,
  getConversionStats,
  updateConversion,
  bulkUpdateConversions,
  refreshConversionEventTime
}; 